/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
*/

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/**
 * Angular content service.
 */
@Injectable()
export class ContentService {
  /**
   * Default Constructor.
   *
   * @param http httpclient
   */
  constructor(private http : HttpClient) {}

  /**
   * Fetch a users published content. This includes pages and collections.
   *
   * @param unitId Id of unit.
   */
  fetchPublishedContent(unitId : string) : Promise< any > {
    return this.http.get(`visibleChildren/${unitId}`).toPromise();
  }
}
